import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from "react-i18next";
import TransactionTable from '../../../components/transactiontable'
import TrackingTable from '../../../components/trackingtable';
import { getTransactionDetails, getAllRefunding } from '../../../services/medium';
import { useSelector } from 'react-redux';
import Tabs from '../../../components/tabs';
import TabPanel from "../../../components/tabs/tabpanel";
import { setLoading } from "../../../reducer/auth/auth";
import { list } from "./data";

const listHeadingKeys = [
    'sessionNumber',
    'transactionId',
    'name',
    'date',
    'sessionDateTime',
    'paymentMethod',
    'amount',
    'currency'
]
const listHeadingTrackingKeys = [
    'sessionNumber',
    'transactionId',
    'name',
    'refundedDateTime',
    'sessionDateTime',
    'paymentMethod',
    'paymentStatus',
    'amount',
    'currency'
]
export default function Transaction() {
    const { t } = useTranslation("mediumMisc");
    const listHeading = listHeadingKeys.map((key) => t(`transactions.headings.${key}`));
    const listHeadingTracking = listHeadingTrackingKeys.map((key) => t(`transactions.headings.${key}`));
    const tabList = useMemo(
        () => list.map((item) => ({ ...item, name: t(`transactions.tabs.${item.name}`, { defaultValue: item.name }) })),
        [t]
    );
    const { id } = useSelector((state) => state.user.user);
    const [transactionsList, setTransactionsList] = useState([]);
    const [trackingList, setTrackingList] = useState([]);
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        getTransactions()
        getRefunding()
    }, [])
const getRefunding = () => {
    let body = {
        medium_id: id,
    }
    getAllRefunding(body).then((data) => {
        console.log(data.data.status, "data")
        if (data.data.status) {
            console.log(data.data.data)
            setTrackingList(data.data.data)

        }
    }).catch(() => { })
}
    const getTransactions = () => {
        let body = {
            medium_id: id,
        }
        getTransactionDetails(body).then((data) => {
            console.log(data.data.status, "data")
            if (data.data.status) {
                console.log(data.data.data)
                setTransactionsList(data.data.data)

            }
        }).catch(() => { })
    }
    return (
       
        <div className="all-medium-page">
        
              <Tabs active={activeTab} list={tabList} setActiveTab={setActiveTab} />
              <TabPanel id={0} activeTab={activeTab}>
                 <TransactionTable listHeading={listHeading} transactionsList={transactionsList} />
              </TabPanel>
              <TabPanel id={1} activeTab={activeTab}>
                <TrackingTable listHeading={listHeadingTracking} transactionsList={trackingList} />
              </TabPanel>
              
            </div>
    )
}
